import './index.scss'

type Props = {
  children?: React.ReactNode
}

export function Pre({ children }: Props) {
  return <pre className="pre">{children}</pre>
}
